import { promiseAction } from 'utils/store';

export const PACKAGES_ACTION_TYPES = {
  LOAD_PACKAGES: 'packages/LOAD_PACKAGES',
  LOAD_COIN_PACKAGES: 'packages/LOAD_COIN_PACKAGES',
  CREATE_COIN_PACKAGE: 'packages/CREATE_COIN_PACKAGE',
  EDIT_COIN_PACKAGE: 'packages/EDIT_COIN_PACKAGE',
  DELETE_COIN_PACKAGE: 'packages/DELETE_COIN_PACKAGE',
  CREATE_PACKAGES: 'packages/CREATE_PACKAGES',
  EDIT_PACKAGES: 'packages/EDIT_PACKAGES',
  DELETE_PACKAGES: 'packages/DELETE_PACKAGES',
}

export const loadPackagesAction = promiseAction(PACKAGES_ACTION_TYPES.LOAD_PACKAGES)
export const createPackagesAction = promiseAction(PACKAGES_ACTION_TYPES.CREATE_PACKAGES)
export const editPackagesAction = promiseAction(PACKAGES_ACTION_TYPES.EDIT_PACKAGES)
export const deletePackagesAction = promiseAction(PACKAGES_ACTION_TYPES.DELETE_PACKAGES)
export const loadCoinPackagesAction = promiseAction(PACKAGES_ACTION_TYPES.LOAD_COIN_PACKAGES)
export const createCoinPackageAction = promiseAction(PACKAGES_ACTION_TYPES.CREATE_COIN_PACKAGE)
export const editCoinPackageAction = promiseAction(PACKAGES_ACTION_TYPES.EDIT_COIN_PACKAGE)
export const deleteCoinPackageAction = promiseAction(PACKAGES_ACTION_TYPES.DELETE_COIN_PACKAGE)